import React from 'react';
import { Typography } from '@mui/material';
import ActionDialog from './ActionDialog';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, message = '삭제하시겠습니까?' }) => {
  return (
    <ActionDialog open={open} onClose={onClose} onConfirm={onConfirm}>
      <Typography sx={{ textAlign: 'center' }}>{message}</Typography>
    </ActionDialog>
  );
};

export default DeleteConfirmDialog;
